import axios from 'axios';
import urlConfig from 'app/config/urlConfig';
import { removeToken } from '@jumbo/components/JumboAuthProvider/authHelpers';

const instance = axios.create({
  withCredentials: false,
  timeout: 20000,
  headers: {
    
  },
});

instance.interceptors.request.use(
  async config => {
    let apiDef = urlConfig[config.endpoint];

    config.url = apiDef.baseUrl + apiDef.endpoint;
    if (config.subfolder)
      config.url = config.url + config.subfolder;
    
    config.method = apiDef.method;
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use((response) => {
  return response;
}, async (error) => {
  if (error.code === 'ERR_NETWORK') {
    return Promise.reject(error);
  }
  const errorData = error.response?.data || error.response
  
  if (error.response?.status == 401) {
    removeToken()
  }
  if (!error.response?.data) {
    errorData.message = getErrorDefault(error?.response?.status)
  }

  if(errorData.message == 'Bad Request') {
    if(errorData.data) {
      errorData.message = Object.values(errorData.data)[0]
    }
  }

  return Promise.reject(errorData);
});


function getErrorDefault(status) {
  switch (status) {
    case 400:
      return status + " : Bad Request"
    case 401:
      return status + " : Unauthorized"
    case 403:
      return status + " : Forbidden"
    case 404:
      return status + " : Not Found"
    case 413:
      return status + " : Payload exceed"
    default:
      return 500 + " : Internal Server Error"
  }
}

export default instance;
